export const REQUEST_TARGET_STATUS = Object.freeze({
  READY: 'ready',
  LOADING: 'loading',
  ERROR: 'error',
  SUCCESS: 'success',
})

export const REQUEST_TARGET_STATUS_GROUPS = Object.freeze({
  ACTIONABLE: [REQUEST_TARGET_STATUS.READY, REQUEST_TARGET_STATUS.ERROR],
  PENDING: [REQUEST_TARGET_STATUS.READY, REQUEST_TARGET_STATUS.LOADING],
  TRACKED: [
    REQUEST_TARGET_STATUS.READY,
    REQUEST_TARGET_STATUS.LOADING,
    REQUEST_TARGET_STATUS.ERROR,
    REQUEST_TARGET_STATUS.SUCCESS,
  ],
})

export const MAIN_ACTION_MODE = Object.freeze({
  RETRY: 'retry',
  REQUEST: 'request',
})
